const PageLoader: React.FC = () => (
  <div className="page-loader">
    <em className="fas fa-circle-notch fa-spin fa-2x text-muted" />
  </div>
);

export default PageLoader;
